import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { withTheme } from '@material-ui/core/styles';
import CallList from './CallList';
const mapStateToProps = ({ scribeConversation: { status }, scribeSession: { captioner: user } }) => ({ user, status });
export default withTheme(withSnackbar(connect(mapStateToProps, {})(CallList)));
